import { AccountState } from './types';

export const INITIAL_ACCOUNT_STATE: AccountState = {
  isAccountPermissionDialogHidden: false,
  isTeamAccountInitialized: false,
  isWorkerAuthorized: false,
  teamAccountAddress: undefined,
  userEndpointToken: undefined,
  workerToken: undefined,
};
